import { setButtonLoading } from "./buttons";

export function createSubmitListener(defaultErrorHandler) {
  return async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = (event.target);
    const downloadCode = form.downloadCode.value.trim();
    const button = form.querySelector(".check-button");
    const eventPayload = {
      downloadCode,
      done: (error) => {
        if (error) defaultErrorHandler();
        setButtonLoading(button, false);
      },
    };
    const checkCodeEvent = new CustomEvent("check-code", { detail: eventPayload, bubbles: true });
    setButtonLoading(button, true);
    form.dispatchEvent(checkCodeEvent);
  };
}
